const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });




const separateEachThreeNumber = Number => {
    if (Number > 999) {

        Number += '';
        Number = Number.replace(',', '');
        var x = Number.split('.');
        var y = x[0];
        var z = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(y))
            y = y.replace(rgx, '$1' + ',' + '$2');
        return y + z;
    } else return Number
}

export {
    getBase64,
    separateEachThreeNumber
}